import { type ReplacementConfig, type IframeReplacement } from '../types';

const isIframe = (element: HTMLElement): element is HTMLIFrameElement =>
  element.tagName === 'IFRAME';

export const iframeProcessor: ReplacementConfig<IframeReplacement> = {
  selector: 'iframe',
  processor: (element) => {
    if (isIframe(element)) {
      return {
        type: 'iframe',
        iframe: element,
      };
    }
    return {};
  },
};
